import {
    DeliveryDetails,
    DeliveryType,
    MenuCategoryData,
    MenuItem,
    MenuItemModifierSet,
    MenuItemModifierSetData
} from "../menu/models";
import { PriceInCurrency } from "../constantsRegistry/models";
import { PaymentProviderType } from "../general/models";


export enum CookingStatus {
    new = 'New'
}

export enum OrderStatus {
    //preorder = 'Preorder',
    new = 'New',
    accepted = 'Accepted',
    paid = 'Paid',
    canceled = 'Canceled',
    ready = 'Ready',
    givenOut = 'GivenOut',
    readyToPickUp = 'ReadyToPickUp',
    givenOutToDelivery = 'GivenOutToDelivery',
    finished = 'Finished',
    canceledByKitchen = 'CanceledByKitchen',
    canceledWithRefund = 'CanceledWithRefund',
    sentToKitchen = 'SentToKitchen',
    acceptedByKitchen = 'AcceptedByKitchen',
}



interface CookingProcessDetails {
    status: CookingStatus;
}


export interface ChosenMenuItemModifier {
    menuItemModifierId: string;
    count: number;
}

export interface ChosenMenuItemModifierSet {
    chosenMenuItemModifiers: ChosenMenuItemModifier[];
    data: MenuItemModifierSetData | null;
    menuItemModifierSetId: number;

}


export interface OrderItem {
    chosenMenuItemModifierSets: ChosenMenuItemModifierSet[];
    comment: string | null;
    cookingProcessDetails: CookingProcessDetails;
    menuItem: MenuItem;
    menuItemsCount: number;
    price: PriceInCurrency;
    priceAfterDiscount: PriceInCurrency;
}



export interface CloudPaymentsDetails{
    type: PaymentProviderType.cloudpayments,
    qrcode?: string,
    receiptLink?: string
}

// export type OrderPaymentDetails = CloudPaymentsDetails;

export interface OrderPaymentDetails {
    isPaid: boolean;
    type: PaymentProviderType;
    receiptLink?: string;
}


export interface Order {
    clientLocaleId: string | null;
    clientSessionId: string | null;
    comment: string;
    createdAt: Date;
    createdByAccountId: number | null;
    deliveryDetails: DeliveryDetails;
    id: number;
    items: OrderItem[];
    menuId: number;
    orderSessionId: string | null;
    organizationBranchId: number;
    paymentDetails: OrderPaymentDetails;
    status: OrderStatus;
    statusHistory: StatusHistoryDetails[];
    tags: string[];
    totalPrice: PriceInCurrency;
    usedMenuCategoriesById: { [key: number]: MenuCategory };
    usedMenuItemModifierSetsById: { [key: number]: MenuItemModifierSet };
    loyaltyProgram: LoyaltyProgram | null;

}
export interface LoyaltyProgram {
    phoneNumber: string;
    typeOperation: OperationType;
}

export enum OperationType {
    deposit = "deposit",
    withdraw = "withdraw"
}

export interface StatusHistoryDetails {
    changedAt: Date;
    changedByAccountId: number | null;
    fromStatus: string;
    toStatus: string;
}

export interface MenuCategory {
    data: MenuCategoryData;
    id: number;
    isRemoved: boolean;
    menuId: number;
    organizationBranchId: number;
}






